import {Component} from '@angular/core';
/**
 * \@title Button varieties
 */
export class ButtonTypesExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'button-types-example',
  templateUrl: 'button-types-example.html',
  styleUrls: ['button-types-example.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ButtonTypesExample_tsickle_Closure_declarations() {
/** @type {?} */
ButtonTypesExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ButtonTypesExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
